module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0015_016.d69cdca9.png";